// [{ 'id': { id, alternativas_equivalentes } }]
function groupByidAlternativaPrincipal(reduced, next) {
  const nextValue = next[Object.keys(next)[0]];

  if (nextValue.id in reduced && nextValue.alternativas_equivalentes) {
    reduced[nextValue.id].alternativas_equivalentes.push(...nextValue.alternativas_equivalentes);
  } else {
    reduced[nextValue.id] = nextValue;
  }

  return reduced;
}

/**
 * Este método faz a conversão da estrutura de dados recebida para a parte do payload
 * que diz respeito ao mapeamento das alternativas (obedecendo a estrutura do payload).
 *
 * @param {[{surveyId, questionId, matchs:[{source, matched}]}]} alternativasMatchs match de alternativas
 * gerados pelo componente responsável por realizar os mapeamentos entre as alternativas
 *
 * @return {[{id, alternativas_equivalentes: {id_pesquisa,id_pergunta,id} }]}
 */
function mapToRequestPayload(alternativasMatchs) {

  const alternativaPrincipalToAlternativaEquivalente = alternativasMatchs
    .map((equivalente) => equivalente.matchs
      .filter((match) => match.source !== null)
      .map((match) => ({
        id: match.source,
        alternativas_equivalentes: [
          {
            id_pesquisa: equivalente.surveyId,
            id_pergunta: equivalente.questionId,
            id: match.matched,
          },
        ],
      })))
    .reduce((reduced, next) => [...reduced, ...next], []) // same as flatMap
    // [{id_alternativa_principal, alternativas_equivalentes: [{id_pesquisa,id_pergunta,id_alternativa_equivalente}] }]
    // groupBy stream
    .reduce((reduced, next) => {
      if (Array.isArray(reduced)) {
        const existingAlternativaPrincipalIdx = reduced.findIndex((current) => current.id === next.id);
        if (existingAlternativaPrincipalIdx < 0) {
          return [...reduced, next];
        }
        reduced[existingAlternativaPrincipalIdx].alternativas_equivalentes.push(...next.alternativas_equivalentes);
      } else if (reduced.id === next.id) {
        reduced.alternativas_equivalentes.push(...next.alternativas_equivalentes);
      } else {
        return [reduced, next];
      }

      return reduced;
    }, []);

  /*  const alternativasPrincipaisByIdNonReduced = alternativasMatchs
    .map((equivalente) => {
      const matchsToReduce = equivalente.matchs
        .filter((match) => match.source !== null)
        .map((match) => {
          const entry = {};
          entry[match.source] = {
            id: match.source,
            alternativas_equivalentes: [{
              id_pesquisa: equivalente.surveyId,
              id_pergunta: equivalente.questionId,
              id: match.matched,
            }],
          };
          return entry;
        });

      if (matchsToReduce.length === 0) {
        return {};
      }

      const reducedMatchs = matchsToReduce.reduce(groupByidAlternativaPrincipal);
      return reducedMatchs;
    });

  const alternativasPrincipaisById = alternativasPrincipaisByIdNonReduced
    .reduce(groupByidAlternativaPrincipal);

  const alternativasPrincipais = Object.keys(alternativasPrincipaisById)
    .map((alternativaPrincipalId) => alternativasPrincipaisById[alternativaPrincipalId]); */

  return alternativaPrincipalToAlternativaEquivalente;
}

export default {
  mapToRequestPayload,
};
